import { Component, ComponentFactoryResolver, OnDestroy, OnInit, ViewChild, OnChanges } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { TaskStep } from 'src/app/data/models/task-step.model';
import { ImagilityBaseResponse } from 'app-models';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs/internal/Subject';
import { getStepDetails, getSubTaskDetails, } from '../../store/selectors/sub-task-details.selectors';
import { PlaceHolderDirective } from '../uscis-place-holder.directive';
import { LetterTemplateComponent } from '../letter-template/letter-template.component';
import { PdfViewComponent } from '../pdf-view/pdf-view.component';
import { LetterPreviewComponent } from '../letter-preview/letter-preview.component';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { environment } from 'environment-configurations';
import { APISupportLetter } from '../../../../../../projects/base-support-letter-library/src/lib/api-support-letter-library.service';
import { SubTaskDetails } from 'src/app/data/models/subTaskDetails.model';



@Component({
  selector: 'i140-support-letter',
  templateUrl: './support-letter.component.html',
  styleUrls: ['./support-letter.component.scss'] 
})
export class SupportLetterComponent implements OnInit, OnChanges {

  disabledControls: boolean;
  typeOfButton: string; // This is required for status update button
  stepDetails: TaskStep;
  observableSubscription$ = new Subject();
  @ViewChild(PlaceHolderDirective, { static: true }) supportLetterPlaceHolder: PlaceHolderDirective;

  subTaskDetails:any;
  isGenerated:Boolean = true;
  isUploaded:Boolean = false;
  uploadedFileName:any;
  generatedOn:any;
  fileSrc:any;
  documentId:any;

  constructor(
    private store: Store<any>,
    public dynamicDialogRef: DynamicDialogRef,
    public dynamicDialogConfig: DynamicDialogConfig,
    private toastr: ToastrService,
    private componentFactoryResolver: ComponentFactoryResolver,
    private apiService:APISupportLetter
  ) {
    sessionStorage.setItem('typeOfLetter', 'SUPLTR');
  }

  ngOnInit(): void {
    // Get Specific step details by passing step code 
    this.store.pipe(select(getStepDetails, { id: this.dynamicDialogConfig.data.stepId })).pipe(takeUntil(this.observableSubscription$)).subscribe((data: TaskStep) => {
      this.typeOfButton = data.isPetitionerAction === 1 || data.isAttorneyAction === 1 ? "MARK_COMPLETE" : "MARK_SUBMIT";
      this.stepDetails = data;
      this.toggleControlsStatus();
      this.handleRedirection('LetterTemplate');
    });
    
    this.store.select(getSubTaskDetails).pipe(takeUntil(this.observableSubscription$)).subscribe((data: SubTaskDetails) => {
      this.subTaskDetails = data;
    });


    this.getGenerateUploadData();
  }

  ngOnChanges(){
    this.toggleControlsStatus();
  }

  loadComponent(component) {
    const componentFactory = this.componentFactoryResolver.resolveComponentFactory(component);
    const viewContainerRef = this.supportLetterPlaceHolder.viewContainerRef;
    viewContainerRef.clear();
    const componentRef = viewContainerRef.createComponent<any>(componentFactory);
    componentRef.instance.data = this.dynamicDialogConfig.data;
    componentRef.instance.redirectionComponent.subscribe((input) => {
      this.handleRedirection(input);
    });
  }

  handleRedirection(componentName: string = 'LetterTemplate') {
    switch (componentName) {
      case 'LetterTemplate':
        this.loadComponent(LetterTemplateComponent);
        break;
      case 'LetterPreview':
        this.loadComponent(LetterPreviewComponent);
        break;
      case 'LetterPDF':
        this.loadComponent(PdfViewComponent);
        break;
    }
  }

  ngOnDestroy() {
    this.observableSubscription$.next();
    this.observableSubscription$.complete();
  }

  getGenerateUploadData(){
    this.apiService.getGeneratedUploadGreenCardDocuments(this.dynamicDialogConfig.data.superTaskId, this.dynamicDialogConfig.data.subTaskId, this.dynamicDialogConfig.data.i140CaseId, 'DOCTYP')
    .pipe(takeUntil(this.observableSubscription$))
    .subscribe((response: ImagilityBaseResponse) => {
      if (response.status == 200 && response.data) {
        
        var currentInd;
        for(let i = 0; i<response.data.length; i++){
          currentInd = response.data.map(function(item){
            return item.fileName;
          }).indexOf('supportletter');
        } 

        let _data = response.data[currentInd];
        this.isGenerated = _data.isGenerated;
        this.isUploaded = _data.isUploaded;
        this.uploadedFileName = _data.uploadedFileName;
        this.generatedOn = _data.generatedOn;
        this.fileSrc = _data.fileLocation;     
        this.documentId =  _data.id; 
      }
    })
  }


  uploadForm(_data){
    let files = _data[0];
    const formData = new FormData();
    formData.append('file', files);
    this.apiService.UploadGreenCardSupportLetter(this.dynamicDialogConfig.data.superTaskId, this.dynamicDialogConfig.data.subTaskId, this.dynamicDialogConfig.data.i140CaseId, 'SUPLTR', formData).pipe(takeUntil(this.observableSubscription$)).subscribe((response: ImagilityBaseResponse) => {
      this.getGenerateUploadData(); 
      if(response){
        this.toastr.success(response.message, 'Success');
      }
  });
  }

  handleGenerateForm(value){
    this.isGenerated = value;
  }

viewDocument(url){
  const docPath = url.substring(23);
  window.open(`${environment.docs}${docPath}`, '_blank');
}

deleteUploadedDocument(id){
  this.apiService.deleteCoverLetter(id, this.subTaskDetails.companyId, this.subTaskDetails.petitionId).pipe(takeUntil(this.observableSubscription$)).subscribe((response: ImagilityBaseResponse) => {
    this.toastr.success(response.message, "Success");
    let _data = response.data;
    this.isGenerated = _data.isGenerated;
    this.isUploaded = _data.isUploaded;
    this.uploadedFileName = _data.uploadedFileName;
    this.generatedOn = _data.generatedOn;
    this.fileSrc = _data.fileLocation;     
    this.documentId =  _data.id; 
    this.getGenerateUploadData(); 
});
}


toggleControlsStatus() {
  this.disabledControls =
    this.stepDetails.stepStatusDetails.stepStatusCode === "NEW" ||
    this.stepDetails.stepStatusDetails.stepStatusCode === "COMPLETE" ||
    this.stepDetails.stepStatusDetails.stepStatusCode === "SUBMIT";
}

}

